import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import React from 'react';
import GradesGoalGraph from 'components/Fragments/GradesGoalGraph/GradesGoalGraph';
import './CreditUsageModule.scss';
import { getUsageStrokeColor } from 'components/Fragments/CreditUsageCircleGraph/CreditUsageCircleGraph';
import { useConfig } from 'hook/config.hook';
import ProgressCreditUsage from 'components/CreditUsageMixDIal/ProgressCreditUsage';

const CreditUsageModuleView = props => {
  const { creditUsageSummary } = props;
  const { grade } = creditUsageSummary;

  const strokeFill = getUsageStrokeColor(
    creditUsageSummary?.utilizationPercentage,
  );

  const { config } = useConfig();
  const label = config?.summaryHeaders?.CREDIT_USAGE?.[grade];

  return (
    <FlexContainer className={'flex-column padLR48 m-padLR16'}>
      <FlexContainer className={'flex-column margt24'}>
        <Label type="Body-2">{label}</Label>

        <FlexContainer className={'margt24 gap-12 margB20 items-align-center'}>
          <ProgressCreditUsage
            size={'small'}
            percent={creditUsageSummary?.utilizationPercentage}
            strokeFill={strokeFill}
          />
          <FlexContainer className={'flex-column width100 gap-8 height40px '}>
            <LeyendRow
              label="Total Balance"
              tradeLineCount={`$${creditUsageSummary?.totalBalance?.toLocaleString()}`}
            />
            <LeyendRow
              label="Total Credit Limit"
              tradeLineCount={`$${creditUsageSummary?.totalCreditLimit?.toLocaleString()}`}
            />
            <LeyendRow
              label="Avoid Spending Over 30%"
              tradeLineCount={`$${creditUsageSummary?.avoidSpendingOver?.toLocaleString()}`}
            />
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
      <FlexContainer>
        <GradesGoalGraph
          gradesGoalClasses={'width100'}
          textClasses={'subTitle4'}
          you={creditUsageSummary?.grade}
          type="usage"
        />
      </FlexContainer>
    </FlexContainer>
  );
};

const LeyendRow = props => {
  const { label, tradeLineCount } = props;

  return (
    <FlexContainer className={'justify-between items-align-center width100'}>
      <FlexContainer className="items-align-center">
        <Label className="caption margR8 ">{label}</Label>
      </FlexContainer>
      <FlexContainer className={'dottedLine flexGrow'} />
      <FlexContainer>
        <Label type="caption margL8" className={'bold'}>
          {tradeLineCount}
        </Label>
      </FlexContainer>
    </FlexContainer>
  );
};

export default CreditUsageModuleView;
